import React from 'react';

const notFoundComponent = () => (
    <h1>
        ¯\_(ツ)_/¯
    </h1>
);

export default notFoundComponent;



// WEBPACK FOOTER //
// ./src/Components/NotFoundComponent.js